import * as T from '../types/store.types';

const wrap = (listener: T.TListener) => {
  return (state: T.IState, action?: T.IAction) => {
    return Promise.resolve(listener(state, action));
  };
};

const createStore: T.TCreateStore = (reducer, initial = {}) => {
  let state: T.IState = { ...initial };
  let listeners: T.TListener[] = [];

  const getState = () => state;

  const dispatch = (action: T.IAction = {}) => {
    state = reducer(getState(), action);
    const resolvers = listeners.map((listener) => listener(state, action));
    return Promise.all(resolvers).then(() => state);
  };

  const subscribe = (listener: T.TListener) => {
    listeners = [...listeners, wrap(listener)];
    let isSubscribed = true;

    return () => {
      if (isSubscribed) {
        isSubscribed = false;
        const index = listeners.indexOf(listener);
        const [left, right] = [
          listeners.slice(0, index),
          listeners.slice(index + 1),
        ];
        listeners = left.concat(right);
      }
      return !isSubscribed;
    };
  };

  dispatch().catch(() => {
    throw new Error('Error on createStore');
  });

  return {
    getState,
    dispatch,
    subscribe,
  };
};

export { createStore };
